<div
  [ngClass]="styleClass"
  (click)="publicProfile()">
  @if (showMedals) {
    <div
      class="ranking-position"
      [ngClass]="getPosition(ranking)">
      @if (ranking.rankingPosition > 3) {
        <slotcom-p
          [bold]="true"
          [text]="ranking.rankingPosition | number: '1.0-0' : ('common.culture' | translate)"
          [fontSize]="setFontSize(ranking.rankingPosition)"
          [shadowBorder]="true"></slotcom-p>
      }
    </div>
  }

  @if (!showMedals) {
    <div class="ranking-position other">
      <slotcom-p
        [bold]="true"
        [text]="ranking.rankingPosition | number: '1.0-0' : ('common.culture' | translate)"
        [fontSize]="setFontSize(ranking.rankingPosition)"
        [shadowBorder]="true"></slotcom-p>
    </div>
  }

  <div class="ranking-avatar">
    <slotcom-avatar [userId]="ranking.userId"></slotcom-avatar>
  </div>
  <div class="ranking-username">
    <slotcom-p
      [bold]="true"
      [text]="ranking.nickName"
      [fontSize]="1.4"
      [shadowBorder]="true"></slotcom-p>
  </div>

  <div class="ranking-points">
    <slotcom-p
      [bold]="true"
      [text]="ranking.rankingScore | number: '1.0-0' : ('common.culture' | translate)"></slotcom-p>
  </div>

  @if (!hideReward) {
    <div class="ranking-reward">
      <div class="present-img"></div>
      <div class="ranking-reward-display">
        <slotcom-p
          [bold]="true"
          [text]="prizeValue | number: '1.0-0' : ('common.culture' | translate)"></slotcom-p>
      </div>
    </div>
  }
</div>
